import { AlertCircle } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export default function ErrorComponent({ error }: { error: Error }) {
  return (
    <Alert variant="destructive" className="bg-red-400 text-primary">
      <AlertCircle className="h-4 w-4 stroke-primary" />
      <AlertTitle>Error</AlertTitle>
      <AlertDescription>{error.message}</AlertDescription>
    </Alert>
  );
}
